export default {"src":"/_next/static/media/exclamation2.7ef653e7.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};